<div style="padding: 25px" *ngIf="paciente && medicalRecord; else loading">
  <div class="flex justify-between items-start mb-6">
    <h1 class="text-xl font-bold text-chathams-blue">Prontuário do Paciente</h1>
    <button
      type="button"
      class="px-5 min-w-max btn btn--secondary h-35 bg-cerise-red"
      (click)="voltar()"
      title="Voltar para lista de pacientes"
    >
      X
    </button>
  </div>

  <!-- 2.1 Informações do Paciente -->
  <div class="mb-6 bg-white rounded border border-gray-300 shadow-sm">
    <div class="px-4 py-2 bg-downy text-white font-semibold rounded-t">Triagem</div>
    <div class="p-4 grid grid-cols-1 md:grid-cols-3 gap-4 text-chathams-blue">
      <div>
        <p><strong>Nome do Paciente:</strong> {{ paciente.name }}</p>
        <p><strong>Documento do Paciente:</strong> {{ paciente.document }}</p>
      </div>
      <div>
        <p><strong>Data de Nascimento:</strong> {{ paciente.birthDate | date: 'dd/MM/yyyy' }}</p>
        <p>
          <strong>Classificação:</strong>
          <span
            class="ml-2 px-3 py-1 rounded text-white"
            [ngClass]="{
              'bg-status-success': paciente.riskClassification === 'Normal',
              'bg-status-warning': paciente.riskClassification === 'Médio',
              'bg-status-error': paciente.riskClassification === 'Alto',
              'bg-gray-400': paciente.riskClassification === 'Não classificado'
            }"
          >
            {{ paciente.riskClassification }}
          </span>
        </p>
      </div>
      <div>
        <p><strong>Data da Triagem:</strong> {{ paciente.createdAt | date: 'dd/MM/yyyy' }}</p>
        <p><strong>Horário:</strong> {{ paciente.createdAt | date: 'HH:mm' }}</p>
      </div>
    </div>
  </div>

  <!-- 2.2 Sinais Vitais -->
  <div class="mb-6 bg-white rounded border border-gray-300 shadow-sm text-chathams-blue">
    <div class="px-4 py-2 bg-downy text-white font-semibold rounded-t">Sinais Vitais</div>
    <div class="p-4 grid grid-cols-1 md:grid-cols-4 gap-4">
      <p *ngIf="pressaoArterial() as pressao"><strong>Pressão Arterial (mmHg):</strong> {{ pressao }}</p>
      <p
        *ngIf="
          medicalRecord.OxygenSaturation !== null &&
          medicalRecord.OxygenSaturation !== undefined &&
          medicalRecord.OxygenSaturation > 0
        "
      >
        <strong>SpO₂ (%):</strong> {{ medicalRecord.OxygenSaturation }}
      </p>
      <p
        *ngIf="
          medicalRecord.BreathingRate !== null &&
          medicalRecord.BreathingRate !== undefined &&
          medicalRecord.BreathingRate > 0
        "
      >
        <strong>Freq. Respiratória (IRPM):</strong> {{ medicalRecord.BreathingRate }}
      </p>
      <p
        *ngIf="medicalRecord.HeartRate !== null && medicalRecord.HeartRate !== undefined && medicalRecord.HeartRate > 0"
      >
        <strong>Freq. Cardíaca (bpm):</strong> {{ medicalRecord.HeartRate }}
      </p>
      <p *ngIf="medicalRecord.Height !== null && medicalRecord.Height !== undefined && medicalRecord.Height > 0">
        <strong>Altura (cm):</strong> {{ medicalRecord.Height }}
      </p>
      <p *ngIf="medicalRecord.Weight !== null && medicalRecord.Weight !== undefined && medicalRecord.Weight > 0">
        <strong>Peso (kg):</strong> {{ medicalRecord.Weight }}
      </p>
      <p *ngIf="medicalRecord.IMC !== null && medicalRecord.IMC !== undefined && medicalRecord.IMC > 0">
        <strong>IMC (kg/m²):</strong> {{ medicalRecord.IMC }}
      </p>
      <p *ngIf="medicalRecord.Temperature"><strong>Temperatura (°C):</strong> {{ medicalRecord.Temperature }}</p>
    </div>
  </div>

  <!-- 2.3 Anamnese -->
  <div class="mb-6 bg-white rounded border border-gray-300 shadow-sm text-chathams-blue">
    <div class="px-4 py-2 bg-downy text-white font-semibold rounded-t">Anamnese</div>
    <div class="p-4 space-y-1">
      <p>Você está no seu peso ideal? {{ resposta(medicalRecord.Overweight) }}</p>
      <p>Você tem pressão alta? {{ hipertensao(medicalRecord.Hypertension) }}</p>
      <p>Você fuma ou fumou por mais de 10 anos? {{ resposta(medicalRecord.SmokerForOverTenYears) }}</p>
      <p>Você tem nível alto de colesterol? {{ resposta(medicalRecord.HighCholesterol) }}</p>
      <p>Você tem diabetes? {{ resposta(medicalRecord.Diabetes) }}</p>
    </div>
  </div>

  <!-- 2.4 Queixa Principal (symptoms) -->
  <div
    class="mb-6 bg-white rounded border border-gray-300 shadow-sm text-chathams-blue"
    *ngIf="
      medicalRecord.symptoms !== null && medicalRecord.symptoms !== undefined && medicalRecord.symptoms.trim() !== ''
    "
  >
    <div class="px-4 py-2 bg-downy text-white font-semibold rounded-t">Queixa Principal</div>
    <div class="p-4 space-y-1">
      <ng-container *ngFor="let queixa of medicalRecord.symptoms.split(';')">
        <p *ngIf="queixa !== null && queixa !== undefined && queixa.trim() !== '' && queixa.split(' ').length <= 4">
          {{ queixa.trim() }}
        </p>
      </ng-container>
    </div>
  </div>

  <!-- 2.5 Evidências de Apoio (evidences) -->
  <div
    class="mb-6 bg-white rounded border border-gray-300 shadow-sm text-chathams-blue"
    *ngIf="
      medicalRecord.evidences !== null && medicalRecord.evidences !== undefined && medicalRecord.evidences.trim() !== ''
    "
  >
    <div class="px-4 py-2 bg-downy text-white font-semibold rounded-t">Evidências de Apoio</div>
    <div class="p-4 space-y-1">
      <ng-container *ngFor="let evidencia of medicalRecord.evidences.split(';')">
        <p *ngIf="evidencia !== null && evidencia !== undefined && evidencia.trim() !== ''">{{ evidencia.trim() }}</p>
      </ng-container>
    </div>
  </div>

  <!-- 2.6 Hipóteses Diagnósticas (conds) -->
  <div
    class="mb-6 bg-white rounded border border-gray-300 shadow-sm text-chathams-blue"
    *ngIf="medicalRecord.conds !== null && medicalRecord.conds !== undefined && medicalRecord.conds.trim() !== ''"
  >
    <div class="px-4 py-2 bg-downy text-white font-semibold rounded-t">Hipóteses Diagnósticas</div>
    <div class="p-4 space-y-1">
      <ng-container *ngFor="let hipotese of medicalRecord.conds.split(';')">
        <p *ngIf="hipotese !== null && hipotese !== undefined && hipotese.trim() !== ''">
          {{ formatDiagnosis(hipotese) }}
        </p>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loading>
  <div style="padding: 25px">
    <p>Carregando prontuário...</p>
  </div>
</ng-template>
